import { Table, TablePagination } from '@components';

import { useAuth } from '@hooks';
import { useWarrantyListContext } from './WarrantyListContext';
import { WarrantyListRow } from './WarrantyListRow';
import { warrantyListColumns } from './warrantyList.config';

export const WarrantyList = () => {
  const { id, itemsPerPage, items, isError, isWorking, offset, totalCount } =
    useWarrantyListContext();

  const { isBeremaUser } = useAuth();

  return (
    <>
      <Table
        isError={isError}
        isWorking={isWorking}
        headerColumns={warrantyListColumns(isBeremaUser)}
        itemsOnPage={items?.length || itemsPerPage}
        list={items || []}
        renderRow={(warranty) => <WarrantyListRow key={warranty?.id} warranty={warranty} />}
      />
      <TablePagination
        id={id}
        start={offset}
        totalCount={totalCount}
        itemsPerPage={itemsPerPage}
        isWorking={isWorking}
      />
    </>
  );
};
